import { withLoading, getExpiringLocalStorage } from '@front-activerse/common-components';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import {
  ONBOARDING_STORAGE_KEY,
  decodeOnboardingData,
  mapOnboardingToSaveVariables,
} from '../Onboarding/onboardingFromUrl';

const SavePaymentContainer = ({
  savePayment,
  userData,
  shoppingCartToken,
  pathPaymentMethods,
  saveOnboardingSettings,
}) => {
  const navigate = useNavigate();

  const saveOnboardingIfPresent = async () => {
    const encoded = localStorage.getItem(ONBOARDING_STORAGE_KEY);

    if (!encoded) return;
    const decoded = decodeOnboardingData(encoded);
    if (decoded) {
      const variables = mapOnboardingToSaveVariables(decoded);
      try {
        await saveOnboardingSettings(variables);
      } catch (error) {
        console.error('Failed to save onboarding settings', error);
      }
    }
    // localStorage.removeItem(ONBOARDING_STORAGE_KEY);
  };

  const handleSavePayment = async () => {
    await saveOnboardingIfPresent();

    const request = {
      productId: +localStorage.getItem('shopppingCartProductId'),
      source: getExpiringLocalStorage('saleSource'),
      saleShoppingId: 1,
      shoppingCartToken,
      email: userData.email,
      promoCode: getExpiringLocalStorage('promoCode'),
    };

    const response = await savePayment(request);

    if (response.data.sale.savePayment.__typename === 'Payment') {
      const paymentToken = response.data.sale.savePayment.token;
      navigate(pathPaymentMethods.replace(':token', paymentToken));
    }
  };

  useEffect(() => {
    handleSavePayment();
  }, []);
  return null;
};
const Placeholder = () => <UniversalPlaceholder simpleLayout fullHeightMinusHeader />;

export default withLoading(SavePaymentContainer, Placeholder);
